// extracted by mini-css-extract-plugin
module.exports = {"link":"WrapperLink_link__1LUwH"};